import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { FC, useCallback, useContext } from 'react'

import { getPromptAnswer } from '../../../components/Inspections/getPromptAnswer'
import {
  EntryWithRelated,
  MultipleChoiceAnswerWithRelated,
  PromptWithRelated
} from '../../../models/inspections'
import { ReplicacheContext } from '../../../providers/ReplicacheProvider/ReplicacheProvider'
import {
  updateInspectionEntryCache,
  updateInspectionPromptCache
} from '../../../replicache/mutateFunction'
import { EntryEntry, PromptEntry } from '../../../sdk'

interface Props {
  prompt: PromptWithRelated
  entry: EntryWithRelated
  inspectionId: string
  handleSelectAnswer: (answers: MultipleChoiceAnswerWithRelated[]) => void
}
export const PromptSelectForSingleSelectCached: FC<Props> = ({
  prompt,
  entry,
  inspectionId,
  handleSelectAnswer
}) => {
  const { replicacheInstance } = useContext(ReplicacheContext)
  const onSubmitForMultipleChoice = useCallback(
    async (answerId: string) => {
      const updatedPrompt: PromptEntry = {
        id: prompt.id!,
        info: {
          ...prompt.info!,
          answer: undefined,
          multipleChoiceAnswer: answerId || undefined,
          multipleChoiceMultipleSelectAnswers: undefined
        }
      }
      updateInspectionPromptCache(
        inspectionId,
        updatedPrompt,
        replicacheInstance
      )
      const answer = prompt.answers.find((answer) => answer.id === answerId)
      const updatedEntry: EntryEntry = {
        id: entry.id!,
        info: {
          ...entry.info!,
          customStatus: answer?.info!.status || entry.info!.customStatus,
          customerNotes: answer?.info!.customerNotes
        }
      }
      updateInspectionEntryCache(inspectionId, updatedEntry, replicacheInstance)
      handleSelectAnswer(answer ? [answer] : [])
    },
    [
      entry.id,
      entry.info,
      handleSelectAnswer,
      inspectionId,
      prompt,
      replicacheInstance
    ]
  )

  return (
    <FormControl
      variant="standard"
      sx={{ width: 200 }}
      required={prompt.info?.required}>
      <InputLabel id="select-answer-label">Answer</InputLabel>
      <Select
        labelId="select-answer-label"
        id="select-answer"
        value={getPromptAnswer(prompt.info!) as string}
        onChange={(event) => {
          onSubmitForMultipleChoice(event.target.value)
        }}
        label="Answer"
        required={prompt.info?.required}>
        {prompt.answers.map((answer) => (
          <MenuItem value={answer.id} key={answer.id!}>
            {answer.info?.question}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
